// A portal's own address with copy + open buttons (Change #100781).

import React from "react";
import { toast } from "react-toastify";
import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

export const copyText = async (text, what = "Link") => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(`${what} copied`);
  } catch (e) {
    toast.info(text);
  }
};

export default function PortalUrl({ url, portalUrlsReady = true, compact = false }) {
  if (!url) {
    return (
      <Typography variant={compact ? "caption" : "body2"} color="text.secondary">
        {portalUrlsReady
          ? "No portal address yet: this company has no portal subdomain set."
          : "Appears once the database update for Change #100781 has run."}
      </Typography>
    );
  }
  return (
    <Stack direction="row" spacing={0.5} alignItems="center" sx={{ minWidth: 0 }}>
      <Typography
        variant={compact ? "caption" : "body2"}
        className="font-monospace text-truncate"
        sx={{ minWidth: 0, maxWidth: compact ? 260 : "100%" }}
        title={url}
      >
        {url}
      </Typography>
      <Tooltip title="Copy link">
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            copyText(url);
          }}
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Open in a new tab">
        <IconButton
          size="small"
          component="a"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          <OpenInNewIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
